import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

export const useLoadingIndicatorStyles = makeStyles<Theme, { size?: 'small' | 'standard'; fullPage?: boolean }>(() => ({
  root: {
    display: 'flex',
    width({ fullPage = false }) {
      return fullPage ? '100%' : undefined;
    },
    maxWidth({ fullPage = false }) {
      return !fullPage ? '1280px' : undefined;
    },
    justifyContent: 'center',
    alignContent: 'center',
    padding: ({ size = 'standard' }) => (size === 'small' ? '8px 6px' : '24px 18px'),
    paddingTop({ fullPage = false }) {
      return fullPage ? '35vh' : undefined;
    }
  }
}));
